import React from "react";

export default function Image({ fill, style, className, ...props }) {
  if (fill) {
    return (
      <img
        {...props}
        className={className}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          ...(style || {}),
        }}
      />
    );
  }

  return <img {...props} className={className} style={style} />;
}
